import { notifyBodyHealthChanged } from "@/lib/bodyHealthChanges";
import { notifyFitnessChanged } from "@/lib/fitnessChanges";
import { notifySleepChanged } from "@/hooks/useSleepResource";

/** Refresh owned saved views; these events carry no records or write receipts. */
export function notifyNativeHealthChanged(ownerId: string, written: { sleep: number; workouts: number; health: number }) {
  if (written.sleep > 0) notifySleepChanged();
  if (written.workouts > 0) notifyFitnessChanged();
  if (written.health > 0) notifyBodyHealthChanged(ownerId, "health");
}
